module.exports = __webpack_public_path__ + "static/media/SDvideo.27bdb932.mov";